function apiUrlBuilder(subdomain = '') {
  const { API_PROTOCOL, API_HOST } = process.env
  const url = `${API_PROTOCOL}://`
  if (subdomain.length) return `${url}${subdomain}.${API_HOST}`
  return `${url}${API_HOST}`
}

/** JSON API base URL (no community subdomain in host; use x-subdomain header). */
function buildApiUrl(url = '') {
  const base = apiUrlBuilder()
  const safeUrl = String(url).replace(/^\//, '')
  return safeUrl ? `${base}/${safeUrl}` : base
}

export default apiUrlBuilder
export { buildApiUrl }
